import { Component, computed, inject } from "@angular/core";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { NetworkFeatureToggle } from "@kno2/common/directives";
import { NetworkIdentityProvidersService } from "@kno2/data-access/network-identity-providers";

@Component({
    selector: "kno2-network-identity-providers",
    imports: [RouterLink, RouterLinkActive, RouterOutlet, NetworkFeatureToggle],
    templateUrl: "./network-identity-providers.component.html"
})
export class NetworkIdentityProvidersComponent {
    private readonly networkIdentityProvidersService = inject(NetworkIdentityProvidersService);
    private readonly currentProvider = this.networkIdentityProvidersService.getNetworkIdentityProvider();

    protected readonly identityProviderExists = computed(() => !!this.currentProvider.value());
}
